"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteSettingsForSaving = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UpdateSiteSettings = _interopRequireDefault(require("../../stagedObjects/UpdateSiteSettings"));

var _pageTemplateSettingsSelectors = require("../pageTemplateSettingsSelectors");

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _reselect = require("reselect");

var INHERIT_FROM_ALL_DOMAINS_VALUE = null;

var shouldInheritIntegration = function shouldInheritIntegration(stagedObject, key) {
  return stagedObject.getIn([_constants.JS_INTEGRATIONS, key, _constants.ENABLED]) === INHERIT_FROM_ALL_DOMAINS_VALUE;
}; // When saving an integration, because it is a nested property if we want to
// indicate that it should be a value inherited from the all-domains level we
// need to delete the key entirely.


var sanitizeIntegrationsForSaving = function sanitizeIntegrationsForSaving(stagedObject) {
  if (shouldInheritIntegration(stagedObject, _constants.AD_ROLL)) {
    stagedObject = stagedObject.deleteIn([_constants.JS_INTEGRATIONS, _constants.AD_ROLL]);
  }

  if (shouldInheritIntegration(stagedObject, _constants.GOOGLE_ANALYTICS)) {
    stagedObject = stagedObject.deleteIn([_constants.JS_INTEGRATIONS, _constants.GOOGLE_ANALYTICS]);
  }

  if (shouldInheritIntegration(stagedObject, _constants.DRIFT)) {
    stagedObject = stagedObject.deleteIn([_constants.JS_INTEGRATIONS, _constants.DRIFT]);
  }

  return stagedObject;
};

var getSiteSettingsForSaving = (0, _reselect.createSelector)([_UpdateSiteSettings.default.getStagedObject, _pageTemplateSettingsSelectors.getStagedAttachedStylesheets], function (stagedObject, stagedAttachedStylesheets) {
  var sanitizedStagedObject = sanitizeIntegrationsForSaving(stagedObject);
  return sanitizedStagedObject.merge((0, _defineProperty2.default)({}, _constants.ATTACHED_STYLESHEETS, stagedAttachedStylesheets ? stagedAttachedStylesheets.toArray() : null)).toJS();
});
exports.getSiteSettingsForSaving = getSiteSettingsForSaving;